import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { UniqueMechanism } from './components/UniqueMechanism';
import { Contents } from './components/Contents';
import { SevenDayPlan } from './components/SevenDayPlan';
import { Objections } from './components/Objections';
import { SocialProof } from './components/SocialProof';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-brand-pink selection:text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <UniqueMechanism data-id="element-4" />
      <Contents data-id="element-5" />
      <SevenDayPlan data-id="element-6" />
      <Objections data-id="element-7" />
      <SocialProof data-id="element-8" />
      <Pricing data-id="element-9" />
      <FAQ data-id="element-10" />

      {/* Final Close Section */}
      <section className="bg-brand-dark text-white py-20 px-4 text-center" data-id="element-11">
        <div className="max-w-2xl mx-auto" data-id="element-12">
          <h2 className="text-3xl font-bold mb-6" data-id="element-13">
            Tu primera venta no te cambia solo el bolsillo… <br data-id="element-14" />
            <span className="text-brand-pink" data-id="element-15">te cambia la cabeza.</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-16">
            Porque después de esa primera venta, ya no eres "una mamá que
            quiere". Eres una mamá que{' '}
            <span className="font-bold text-white" data-id="element-17">puede</span>.
          </p>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-pink hover:bg-rose-400 text-brand-dark font-bold py-4 px-8 rounded-full text-xl transition-all transform hover:-translate-y-1 shadow-lg shadow-brand-pink/30" data-id="element-18">
            Descargar Mamá Digital 2.0 ahora
          </button>
        </div>
      </section>

      <Footer data-id="element-19" />
    </div>;
}